import React, {useContext, useEffect, useState, useRef, useCallback} from 'react';
import styles from '../../styles/dashboard.module.css';
import gpsStyles from './gps.module.css';
import Header from "../../components/header/header";
import PageTitle from "../../components/page_title/page_title";
import GPSTabs from "./components/gps_tabs";
import GoogleMapReact from 'google-map-react';
import axiosInstance from "../../AxiosInstance";
import useMQTTGPS from "../../components/mqtt_service/mqtt_gps";
import useMQTTIndoor from "../../components/mqtt_service/mqtt_indoor";
import MyContext from "../../Context";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faUser, faBox, faBatteryThreeQuarters, faRoute,
    faSearch, faTriangleExclamation, faLocationCrosshairs, faLayerGroup,
    faVideo, faTrash, faPlus, faTimes
} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";
import GPSIndoorContent from "./gps_indoor";
import CameraViewer from "../../components/camera_viewer/camera_viewer";

function AssetMarker({asset, onClick, isSelected, hasWarning, hasSOS}) {
    const bgColor = hasSOS
        ? '#7C3AED'
        : hasWarning
            ? '#EF4444'
            : isSelected
                ? '#3B82F6'
                : (asset.is_human ? '#10B981' : '#F59E0B');

    return (
        <div
            onClick={(e) => { e.stopPropagation(); onClick(asset); }}
            style={{
                transform: 'translate(-50%, -100%)',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <div style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                backgroundColor: bgColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '3px solid white',
                boxShadow: hasSOS ? '0 0 0 3px #7C3AED, 0 2px 6px rgba(0,0,0,0.3)' : '0 2px 6px rgba(0,0,0,0.3)',
                position: 'relative',
            }}>
                <FontAwesomeIcon icon={asset.is_human ? faUser : faBox} color="white" size="sm"/>
                {hasSOS && (
                    <div style={{
                        position: 'absolute', top: '-6px', right: '-8px',
                        backgroundColor: '#7C3AED', border: '1px solid white',
                        borderRadius: '3px', padding: '0 3px',
                        fontSize: '7px', fontWeight: '700', color: 'white', letterSpacing: '0.5px',
                    }}>
                        SOS
                    </div>
                )}
                {!hasSOS && hasWarning && (
                    <div style={{
                        position: 'absolute', top: '-4px', right: '-4px',
                        width: '14px', height: '14px', borderRadius: '50%',
                        backgroundColor: '#FEF2F2', border: '1px solid #EF4444',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                        <FontAwesomeIcon icon={faTriangleExclamation} color="#EF4444" style={{fontSize: '8px'}}/>
                    </div>
                )}
            </div>
            <div style={{
                marginTop: '2px',
                fontSize: '11px',
                fontWeight: '600',
                color: hasSOS ? '#7C3AED' : hasWarning ? '#EF4444' : '#1E293B',
                textShadow: '0 0 3px white, 0 0 3px white',
                whiteSpace: 'nowrap',
            }}>
                {asset.name}
            </div>
        </div>
    );
}

function CameraMarker({camera, onClick, isSelected}) {
    const color = isSelected ? '#0EA5E9' : '#06B6D4';
    return (
        <div
            onClick={(e) => { e.stopPropagation(); onClick(camera); }}
            style={{ transform: 'translate(-50%, -100%)', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >
            <div style={{
                width: '34px', height: '34px', borderRadius: '50%',
                backgroundColor: color,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                border: isSelected ? '3px solid white' : '2px solid white',
                boxShadow: '0 2px 6px rgba(0,0,0,0.35)',
            }}>
                <FontAwesomeIcon icon={faVideo} style={{ color: '#fff', fontSize: '13px' }} />
            </div>
            <div style={{ width: 0, height: 0, borderLeft: '6px solid transparent', borderRight: '6px solid transparent', borderTop: `8px solid ${color}` }} />
            <div style={{ fontSize: '11px', fontWeight: '600', color: '#0E7490', textShadow: '0 0 3px white, 0 0 3px white', whiteSpace: 'nowrap', marginTop: '1px' }}>
                {camera.camera_name}
            </div>
        </div>
    );
}

function AssetSearchDropdown({assets, onSelect, filterFn}) {
    const [search, setSearch] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedName, setSelectedName] = useState('');

    const filtered = assets.filter(a => {
        if (!search) return true;
        return filterFn(a, search.toLowerCase());
    }).slice(0, 50);

    return (
        <div style={{position: 'relative'}}>
            <div style={{position: 'relative'}}>
                <FontAwesomeIcon icon={faSearch} style={{position: 'absolute', left: '8px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8', fontSize: '12px'}}/>
                <input
                    type="text"
                    placeholder="Search by name, ID doc, or device..."
                    value={selectedName || search}
                    onChange={e => {
                        setSearch(e.target.value);
                        setSelectedName('');
                        setShowDropdown(true);
                    }}
                    onFocus={() => setShowDropdown(true)}
                    onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
                    style={{width: '100%', padding: '6px 8px 6px 28px', borderRadius: '4px', border: '1px solid #CBD5E1', fontSize: '13px'}}
                />
                {selectedName && (
                    <span
                        style={{position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#94A3B8', fontSize: '12px'}}
                        onClick={() => { setSelectedName(''); setSearch(''); }}
                    >&times;</span>
                )}
            </div>
            {showDropdown && !selectedName && (
                <div style={{
                    position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 10,
                    maxHeight: '200px', overflowY: 'auto',
                    backgroundColor: 'white', border: '1px solid #CBD5E1', borderRadius: '4px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                }}>
                    {filtered.map(a => (
                        <div
                            key={a.id}
                            style={{padding: '6px 8px', cursor: 'pointer', fontSize: '13px', borderBottom: '1px solid #F1F5F9'}}
                            onMouseDown={() => {
                                setSelectedName(a.name);
                                setSearch('');
                                setShowDropdown(false);
                                onSelect(a);
                            }}
                        >
                            <div style={{fontWeight: '500'}}>{a.name}</div>
                            <div style={{fontSize: '11px', color: '#94A3B8'}}>
                                {a.identification_number ? `Doc: ${a.identification_number}` : ''}
                                {a.identification_number && a.active_gps_device ? ' | ' : ''}
                                {a.active_gps_device ? `Device: ${a.active_gps_device.name}` : 'No GPS device'}
                            </div>
                        </div>
                    ))}
                    {filtered.length === 0 && (
                        <div style={{padding: '8px', fontSize: '13px', color: '#94A3B8', textAlign: 'center'}}>No results</div>
                    )}
                </div>
            )}
        </div>
    );
}

export default function GPSMap() {
    const {t} = useTranslation();
    const project_id = parseInt(localStorage.getItem('project_id'));
    const {corporateGroup} = useContext(MyContext);
    const [assets, setAssets] = useState([]);
    const [indoorDeviceIds, setIndoorDeviceIds] = useState(new Set());
    const [zones, setZones] = useState([]);
    const [warnings, setWarnings] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [selectedVariables, setSelectedVariables] = useState([]);
    const [mapApi, setMapApi] = useState(null);
    const [mapInstance, setMapInstance] = useState(null);
    const [mapType, setMapType] = useState(() => localStorage.getItem('gps_map_type') || 'hybrid');
    const infoWindowRef = useRef(null);
    const zonePolygonsRef = useRef([]);
    const zoneClickRef = useRef(false);
    const markerClickRef = useRef(false);

    // Route drawing state
    const [showRoutePanel, setShowRoutePanel] = useState(false);
    const [routeAssetId, setRouteAssetId] = useState('');
    const [routeSearch, setRouteSearch] = useState('');
    const [routeSelectedName, setRouteSelectedName] = useState('');
    const [showRouteDropdown, setShowRouteDropdown] = useState(false);
    const [routeFrom, setRouteFrom] = useState('');
    const [routeTo, setRouteTo] = useState('');
    const [routePoints, setRoutePoints] = useState([]);
    const [routePolyline, setRoutePolyline] = useState(null);
    const [routeError, setRouteError] = useState('');

    const [gpsActions, setGpsActions] = useState([]);
    const selectedSosActionRef = useRef(null);

    // Outdoor camera state
    const [mapCameras, setMapCameras] = useState([]);
    const [allCameras, setAllCameras] = useState([]);
    const [selectedCamera, setSelectedCamera] = useState(null);
    const [showCameras, setShowCameras] = useState(true);
    const [showCameraPanel, setShowCameraPanel] = useState(false);
    const [cameraPlacementMode, setCameraPlacementMode] = useState(false);
    const [pendingCameraLatLng, setPendingCameraLatLng] = useState(null);
    const [showCameraPicker, setShowCameraPicker] = useState(false);
    const [cameraPickerSearch, setCameraPickerSearch] = useState('');
    const [cameraLoading, setCameraLoading] = useState(false);
    const [showCameraViewer, setShowCameraViewer] = useState(false);
    const [cameraSearch, setCameraSearch] = useState('');
    const cameraClickRef = useRef(false);

    const {positions} = useMQTTGPS(project_id);
    const {positions: indoorPositions} = useMQTTIndoor(project_id);

    const mapCenter = {
        lat: corporateGroup?.gps_map_center_lat || 14.72,
        lng: corporateGroup?.gps_map_center_lng || -75.12
    };
    const mapZoom = corporateGroup?.gps_map_zoom || 15;

    const searchFilter = useCallback((a, q) => {
        const name = (a.name || '').toLowerCase();
        const doc = (a.identification_number || '').toLowerCase();
        const deviceName = (a.active_gps_device?.name || '').toLowerCase();
        const deviceId = String(a.active_gps_device?.id || '');
        return name.includes(q) || doc.includes(q) || deviceName.includes(q) || deviceId.includes(q);
    }, []);

    useEffect(() => {
        if (!project_id) return;
        let isMounted = true;
        axiosInstance.get(`gps_asset/?project_id=${project_id}`).then(res => { if (isMounted) setAssets(res.data); });
        axiosInstance.get(`indoor_position/?project_id=${project_id}`).then(res => {
            if (isMounted) setIndoorDeviceIds(new Set(res.data.map(p => p.device_user)));
        }).catch(() => {});
        axiosInstance.get(`gps_action/?project_id=${project_id}`).then(res => {
            if (!isMounted) return;
            const data = res.data;
            setGpsActions(Array.isArray(data) ? data : (data.results || []));
        });
        axiosInstance.get(`map_zone/?project_id=${project_id}`).then(res => { if (isMounted) setZones(res.data); });
        axiosInstance.get(`zone_presence/?project_id=${project_id}`).then(res => {
            if (!isMounted) return;
            const data = res.data;
            setWarnings(Array.isArray(data) ? data : (data.results || []));
        }).catch(() => {});
        axiosInstance.get(`map_camera/?project_id=${project_id}`).then(res => { if (isMounted) setMapCameras(Array.isArray(res.data) ? res.data : (res.data?.results || [])); }).catch(console.error);
        axiosInstance.get(`ip_camera/?project_id=${project_id}`).then(res => { if (isMounted) setAllCameras(Array.isArray(res.data) ? res.data : (res.data?.results || [])); }).catch(() => {});
        return () => { isMounted = false; };
    }, [project_id]);

    // Sync real-time indoor MQTT arrivals into indoorDeviceIds
    useEffect(() => {
        const ids = Object.keys(indoorPositions).map(Number).filter(Boolean);
        if (ids.length > 0) {
            setIndoorDeviceIds(prev => {
                const next = new Set(prev);
                ids.forEach(id => next.add(id));
                return next;
            });
        }
    }, [indoorPositions]); // eslint-disable-line react-hooks/exhaustive-deps

    // Refresh warnings periodically
    useEffect(() => {
        if (!project_id) return;
        const interval = setInterval(() => {
            axiosInstance.get(`zone_presence/?project_id=${project_id}`).then(res => {
                const data = res.data;
                setWarnings(Array.isArray(data) ? data : (data.results || []));
            }).catch(() => {});
        }, 30000);
        return () => clearInterval(interval);
    }, [project_id]);

    // Register SOS trigger for InfoWindow button clicks
    useEffect(() => {
        window.triggerGPSSOS = async (assetId, actionId) => {
            const btn = document.getElementById(`sos-btn-${assetId}`);
            if (btn) { btn.textContent = 'Sending...'; btn.disabled = true; }
            try {
                await axiosInstance.post('gps_asset/send_action/', {
                    gps_action_id: actionId,
                    asset_ids: [assetId],
                    group_ids: [],
                });
                if (btn) {
                    btn.textContent = 'SOS Sent ✓';
                    btn.style.backgroundColor = '#10B981';
                    setTimeout(() => {
                        if (btn) {
                            btn.textContent = 'SOS';
                            btn.disabled = false;
                            btn.style.backgroundColor = '#EF4444';
                        }
                    }, 2500);
                }
            } catch (e) {
                if (btn) {
                    btn.textContent = 'Error';
                    btn.style.backgroundColor = '#F59E0B';
                    setTimeout(() => {
                        if (btn) {
                            btn.textContent = 'SOS';
                            btn.disabled = false;
                            btn.style.backgroundColor = '#EF4444';
                        }
                    }, 2500);
                }
            }
        };
        return () => { delete window.triggerGPSSOS; };
    }, []);

    // Poll variable_data for the selected asset
    useEffect(() => {
        if (!selectedAsset?.active_gps_device?.id) {
            setSelectedVariables([]);
            return;
        }
        let isMounted = true;
        const deviceId = selectedAsset.active_gps_device.id;
        const fetchVars = () => {
            axiosInstance.get(`variable_data/?device_id=${deviceId}`)
                .then(res => { if (isMounted) setSelectedVariables(res.data); })
                .catch(() => {});
        };
        fetchVars();
        const interval = setInterval(fetchVars, 15000);
        return () => { isMounted = false; clearInterval(interval); };
    }, [selectedAsset?.id]);

    // Build set of device_user IDs with warnings
    const warningUserIds = new Set(warnings.map(w => w.device_user));

    // Build set of device_user IDs with active SOS (from real-time MQTT positions)
    const sosUserIds = new Set(assets.filter(a => positions[a.id]?.is_sos).map(a => a.id));

    // Draw zone polygons when map and zones are ready
    useEffect(() => {
        if (!mapApi || !mapInstance) return;

        // Clear existing polygons
        zonePolygonsRef.current.forEach(p => p.setMap(null));
        zonePolygonsRef.current = [];

        if (zones.length === 0) return;

        zones.forEach(zone => {
            if (!zone.geometry) return;
            try {
                const coordStr = zone.geometry.replace('POLYGON((', '').replace('))', '');
                const coords = coordStr.split(',').map(pair => {
                    const [lng, lat] = pair.trim().split(' ').map(Number);
                    return {lat, lng};
                });

                const polygon = new mapApi.Polygon({
                    paths: coords,
                    map: mapInstance,
                    strokeColor: '#3B82F6',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#3B82F6',
                    fillOpacity: 0.15,
                });

                // Click on zone polygon opens InfoWindow
                mapApi.event.addListener(polygon, 'click', (e) => {
                    zoneClickRef.current = true;
                    if (infoWindowRef.current) infoWindowRef.current.close();
                    const iw = new mapApi.InfoWindow({
                        content: `<div style="font-family:sans-serif;min-width:150px">
                            <div style="font-weight:600;font-size:14px;margin-bottom:4px">${zone.name}</div>
                            <div style="font-size:12px;color:#64748B">Max overtime: ${zone.max_overtime_minutes ? zone.max_overtime_minutes + ' min' : 'No limit'}</div>
                        </div>`,
                        position: e.latLng,
                    });
                    iw.open(mapInstance);
                    infoWindowRef.current = iw;
                });

                zonePolygonsRef.current.push(polygon);
            } catch (e) {
                console.error('Error drawing zone polygon:', e);
            }
        });
    }, [mapApi, mapInstance, zones]);

    // Merge MQTT real-time positions with initial API data
    const getAssetPosition = (asset) => {
        const mqttPos = positions[asset.id];
        if (mqttPos) return {lat: mqttPos.latitude, lng: mqttPos.longitude};
        return asset.current_position;
    };

    const getAssetBattery = (asset) => {
        const mqttPos = positions[asset.id];
        if (mqttPos) return mqttPos.battery;
        return asset.active_gps_device?.battery;
    };

    const getAssetLastMessage = (asset) => {
        const mqttPos = positions[asset.id];
        if (mqttPos?.last_message) return mqttPos.last_message;
        return asset.active_gps_device?.last_message;
    };

    const handleApiLoaded = ({map, maps}) => {
        setMapApi(maps);
        setMapInstance(map);
        map.setMapTypeId(localStorage.getItem('gps_map_type') || 'hybrid');
    };

    const MAP_TYPES = ['hybrid', 'satellite', 'roadmap', 'terrain'];
    const MAP_TYPE_LABELS = { hybrid: 'Hybrid', satellite: 'Satellite', roadmap: 'Map', terrain: 'Terrain' };

    const cycleMapType = () => {
        const next = MAP_TYPES[(MAP_TYPES.indexOf(mapType) + 1) % MAP_TYPES.length];
        setMapType(next);
        localStorage.setItem('gps_map_type', next);
        if (mapInstance) mapInstance.setMapTypeId(next);
    };

    const buildInfoWindowContent = (asset, pos, battery, warning, vars, sosAction) => {
        const lastMsg = getAssetLastMessage(asset);
        const varsHtml = vars.length > 0
            ? `<div style="margin-top:6px;padding-top:6px;border-top:1px solid #E2E8F0">
                <div style="font-weight:600;font-size:12px;margin-bottom:4px">Variables</div>
                ${vars.map(v =>
                    `<div style="display:flex;justify-content:space-between;gap:8px;padding:2px 0">
                        <span style="color:#64748B">${v.variable?.name || '—'}</span>
                        <span style="font-weight:500">${v.value != null ? v.value + (v.variable?.unit ? ' ' + v.variable.unit : '') : '—'}</span>
                    </div>`
                ).join('')}
               </div>`
            : '';
        return `<div style="font-family:sans-serif;min-width:180px">
            <div style="font-weight:600;font-size:14px;margin-bottom:4px">${asset.name}</div>
            <div style="font-size:12px;color:#64748B">
                <div>${asset.is_human ? 'Person' : 'Asset'}</div>
                ${asset.identification_number ? `<div>Doc: ${asset.identification_number}</div>` : ''}
                <div style="margin-top:2px">Battery: ${battery}%</div>
                ${asset.active_gps_device ? `<div>Device: ${asset.active_gps_device.name}</div>` : ''}
                ${lastMsg ? `<div>Last msg: ${new Date(lastMsg).toLocaleString()}</div>` : ''}
                ${warning ? `<div style="color:#EF4444;font-weight:600;margin-top:4px">Warning: ${warning.warning_trigger} in ${warning.zone_name}</div>` : ''}
                ${positions[asset.id]?.is_sos ? '<div style="color:#7C3AED;font-weight:700;margin-top:4px">&#x1F198; SOS Button Active</div>' : ''}
            </div>
            ${varsHtml}
            <div style="display:flex;gap:6px;margin-top:8px">
                <a href="https://www.google.com/maps/dir/?api=1&destination=${pos.lat},${pos.lng}" target="_blank" rel="noopener noreferrer"
                   style="flex:1;display:block;padding:6px 0;text-align:center;background:#1E293B;color:white;border-radius:6px;font-size:12px;font-weight:600;text-decoration:none">
                    Go to location
                </a>
                ${sosAction ? `<button
                    id="sos-btn-${asset.id}"
                    onclick="window.triggerGPSSOS(${asset.id}, ${sosAction.id})"
                    style="padding:6px 10px;background:#EF4444;color:white;border:none;border-radius:6px;font-size:12px;font-weight:700;cursor:pointer;letter-spacing:1px">
                    SOS
                </button>` : ''}
            </div>
        </div>`;
    };

    const openAssetPopup = async (asset) => {
        setSelectedAsset(asset);
        const pos = getAssetPosition(asset);
        if (!pos || !mapApi || !mapInstance) return;

        // Center map on asset
        mapInstance.panTo({lat: pos.lat, lng: pos.lng});

        // Find SOS action for this asset's device type
        const deviceTypeId = asset.active_gps_device?.device_type_id;
        const sosAction = deviceTypeId
            ? gpsActions.find(a => a.is_sos && a.device_type === deviceTypeId) || null
            : null;
        selectedSosActionRef.current = sosAction;

        // Fetch fresh variable data before building the popup
        let freshVars = [];
        if (asset.active_gps_device?.id) {
            try {
                const res = await axiosInstance.get(`variable_data/?device_id=${asset.active_gps_device.id}`);
                freshVars = res.data;
                setSelectedVariables(freshVars);
            } catch (e) {}
        }

        const battery = Math.round(getAssetBattery(asset) || 0);
        const warning = warnings.find(w => w.device_user === asset.id);
        if (infoWindowRef.current) infoWindowRef.current.close();
        const iw = new mapApi.InfoWindow({
            content: buildInfoWindowContent(asset, pos, battery, warning, freshVars, sosAction),
            position: {lat: pos.lat, lng: pos.lng},
            pixelOffset: new mapApi.Size(0, -60),
        });
        iw.open(mapInstance);
        infoWindowRef.current = iw;
    };

    // Update open InfoWindow content when variables or MQTT positions change
    useEffect(() => {
        if (!selectedAsset || !infoWindowRef.current || !mapApi || !mapInstance) return;
        const pos = getAssetPosition(selectedAsset);
        if (!pos) return;
        const battery = Math.round(getAssetBattery(selectedAsset) || 0);
        const warning = warnings.find(w => w.device_user === selectedAsset.id);
        infoWindowRef.current.setContent(
            buildInfoWindowContent(selectedAsset, pos, battery, warning, selectedVariables, selectedSosActionRef.current)
        );
    }, [selectedVariables, positions]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleMarkerClick = (asset) => {
        markerClickRef.current = true;
        openAssetPopup(asset);
    };

    const handleSearchSelect = (asset) => {
        openAssetPopup(asset);
    };

    const handleAlarmRowClick = (warning) => {
        const asset = assets.find(a => a.id === warning.device_user);
        if (asset) openAssetPopup(asset);
    };

    const drawRoute = () => {
        if (!routeAssetId || !routeFrom || !routeTo) return;
        setRouteError('');

        const diffHours = (new Date(routeTo) - new Date(routeFrom)) / (1000 * 60 * 60);
        if (diffHours > 24) {
            setRouteError('Maximum range is 24 hours.');
            return;
        }
        if (diffHours <= 0) {
            setRouteError('Start date must be before end date.');
            return;
        }

        // Clear previous polyline
        if (routePolyline) routePolyline.setMap(null);

        axiosInstance.get(`gps_position_history/?device_user_id=${routeAssetId}&from=${routeFrom}&to=${routeTo}`)
            .then(res => {
                setRoutePoints(res.data);
                if (mapApi && mapInstance && res.data.length > 0) {
                    const path = res.data.map(p => ({lat: p.latitude, lng: p.longitude}));
                    const polyline = new mapApi.Polyline({
                        path,
                        map: mapInstance,
                        strokeColor: '#EF4444',
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                    });
                    setRoutePolyline(polyline);

                    // Add start/end markers
                    new mapApi.Marker({
                        position: path[0],
                        map: mapInstance,
                        label: 'A',
                    });
                    new mapApi.Marker({
                        position: path[path.length - 1],
                        map: mapInstance,
                        label: 'B',
                    });
                }
            });
    };

    const clearRoute = () => {
        if (routePolyline) routePolyline.setMap(null);
        setRoutePolyline(null);
        setRoutePoints([]);
    };

    return (
        <div className={styles.dashboard_container}>
            <Header sidebarIndex={1}/>

            <div className={styles.dashboardInnerContainer}>
                <PageTitle title={t('gps.assets.title')}/>
                <GPSTabs active={0}/>

                <div className={gpsStyles.gpsLayout}>
                    {/* Map */}
                    <div className={gpsStyles.gpsMapWrapper} style={{ position: 'relative' }}>
                        {/* Map type toggle */}
                        <button
                            onClick={cycleMapType}
                            title={`Current: ${MAP_TYPE_LABELS[mapType]} — click to switch`}
                            style={{
                                position: 'absolute', top: '10px', left: '10px', zIndex: 10,
                                background: 'rgba(30,41,59,0.9)', color: '#fff', border: 'none',
                                borderRadius: '6px', padding: '6px 10px', cursor: 'pointer',
                                fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '5px',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
                            }}
                        >
                            <FontAwesomeIcon icon={faLayerGroup} />
                            {MAP_TYPE_LABELS[mapType]}
                        </button>
                        <button
                            onClick={() => setShowCameras(v => !v)}
                            title={showCameras ? 'Hide cameras' : 'Show cameras'}
                            style={{
                                position: 'absolute', top: '10px', left: '120px', zIndex: 10,
                                background: showCameras ? 'rgba(6,182,212,0.9)' : 'rgba(30,41,59,0.9)',
                                color: '#fff', border: 'none', borderRadius: '6px', padding: '6px 10px',
                                cursor: 'pointer', fontSize: '12px', fontWeight: '600',
                                display: 'flex', alignItems: 'center', gap: '5px',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
                            }}
                        >
                            <FontAwesomeIcon icon={faVideo} />
                            Cameras
                        </button>
                        <GoogleMapReact
                            defaultCenter={mapCenter}
                            defaultZoom={mapZoom}
                            bootstrapURLKeys={{key: 'AIzaSyAqEBaEszO4nf-OBb-VarsUZ_47bTwwc9g', libraries: ['drawing']}}
                            yesIWantToUseGoogleMapApiInternals
                            onGoogleApiLoaded={handleApiLoaded}
                            options={{mapTypeId: 'hybrid'}}
                            onClick={({ lat, lng }) => {
                                if (zoneClickRef.current) {
                                    zoneClickRef.current = false;
                                    return;
                                }
                                if (markerClickRef.current) {
                                    markerClickRef.current = false;
                                    return;
                                }
                                if (cameraPlacementMode) {
                                    setPendingCameraLatLng({ lat, lng });
                                    setShowCameraPicker(true);
                                    return;
                                }
                                setSelectedAsset(null);
                                setSelectedCamera(null);
                                if (infoWindowRef.current) infoWindowRef.current.close();
                            }}
                        >
                            {assets.map(asset => {
                                if (indoorDeviceIds.has(asset.id)) {
                                    const outdoorPos = positions[asset.id];
                                    const outdoorTime = outdoorPos?.last_message ? new Date(outdoorPos.last_message).getTime() : 0;
                                    // Hide outdoor marker if GPS has not been published in the last 2 minutes.
                                    // In hybrid mode (1-2 beacons + GPS), GPS IS published simultaneously → outdoorTime is fresh → keep marker.
                                    // In indoor_full / indoor_degraded, GPS is NOT published → outdoorTime goes stale → hide marker.
                                    if (Date.now() - outdoorTime > 120000) return null;
                                }
                                const pos = getAssetPosition(asset);
                                if (!pos) return null;
                                return (
                                    <AssetMarker
                                        key={asset.id}
                                        lat={pos.lat}
                                        lng={pos.lng}
                                        asset={asset}
                                        isSelected={selectedAsset?.id === asset.id}
                                        hasWarning={warningUserIds.has(asset.id)}
                                        hasSOS={sosUserIds.has(asset.id)}
                                        onClick={handleMarkerClick}
                                    />
                                );
                            })}
                            {showCameras && mapCameras.map(mc => (
                                <CameraMarker
                                    key={mc.id}
                                    lat={mc.latitude}
                                    lng={mc.longitude}
                                    camera={mc}
                                    isSelected={selectedCamera?.id === mc.id}
                                    onClick={(cam) => { cameraClickRef.current = true; setSelectedCamera(cam); setShowCameraViewer(true); setSelectedAsset(null); if (infoWindowRef.current) infoWindowRef.current.close(); }}
                                />
                            ))}
                        </GoogleMapReact>
                        {/* Camera placement mode overlay */}
                        {cameraPlacementMode && (
                            <div style={{
                                position: 'absolute', top: '50px', left: '50%', transform: 'translateX(-50%)',
                                background: 'rgba(6,182,212,0.95)', color: '#fff', borderRadius: '8px',
                                padding: '8px 16px', fontSize: '13px', fontWeight: '600', zIndex: 10,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.3)', pointerEvents: 'none',
                            }}>
                                <FontAwesomeIcon icon={faVideo} style={{ marginRight: '6px' }} />
                                Click on the map to place the camera
                            </div>
                        )}
                    </div>

                    {/* Side Panel */}
                    <div className={gpsStyles.gpsSidePanel} style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
                        {/* Search bar */}
                        <div style={{
                            padding: '12px',
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            border: '1px solid #E2E8F0',
                        }}>
                            <div style={{fontWeight: '600', fontSize: '13px', marginBottom: '8px', color: '#334155'}}>
                                <FontAwesomeIcon icon={faSearch} size="sm"/> {t('common.search')}
                            </div>
                            <AssetSearchDropdown
                                assets={assets}
                                onSelect={handleSearchSelect}
                                filterFn={searchFilter}
                            />
                        </div>

                        {/* Selected asset info */}
                        {selectedAsset && (
                            <div style={{
                                padding: '16px',
                                backgroundColor: 'white',
                                borderRadius: '8px',
                                border: warningUserIds.has(selectedAsset.id) ? '2px solid #EF4444' : '1px solid #E2E8F0',
                            }}>
                                <div className="d-flex align-items-center gap-2" style={{marginBottom: '8px'}}>
                                    <div style={{fontWeight: '600', fontSize: '16px'}}>
                                        {selectedAsset.name}
                                    </div>
                                    {warningUserIds.has(selectedAsset.id) && (
                                        <FontAwesomeIcon icon={faTriangleExclamation} color="#EF4444" size="sm"/>
                                    )}
                                </div>
                                <div style={{fontSize: '13px', color: '#64748B'}}>
                                    <div>{selectedAsset.is_human ? t('gps.assets.person') : t('gps.assets.asset')}</div>
                                    {selectedAsset.identification_number && (
                                        <div className="mt-1">Doc: {selectedAsset.identification_number}</div>
                                    )}
                                    <div className="d-flex align-items-center gap-1 mt-1">
                                        <FontAwesomeIcon icon={faBatteryThreeQuarters} size="sm"/>
                                        {Math.round(getAssetBattery(selectedAsset) || 0)}%
                                    </div>
                                    {selectedAsset.active_gps_device && (
                                        <div className="mt-1">Device: {selectedAsset.active_gps_device.name}</div>
                                    )}
                                    {getAssetLastMessage(selectedAsset) && (
                                        <div className="mt-1" style={{fontSize: '12px'}}>
                                            Last: {new Date(getAssetLastMessage(selectedAsset)).toLocaleString()}
                                        </div>
                                    )}
                                    {positions[selectedAsset.id]?.is_sos && (
                                        <div style={{color: '#7C3AED', fontWeight: '700', marginTop: '4px', fontSize: '12px'}}>
                                            🆘 {t('gps.sos.sosButtonActive')}
                                        </div>
                                    )}
                                    {warnings.filter(w => w.device_user === selectedAsset.id).map(w => (
                                        <div key={w.id} style={{color: '#EF4444', fontWeight: '600', marginTop: '4px', fontSize: '12px'}}>
                                            Warning: {w.warning_trigger} in {w.zone_name}
                                        </div>
                                    ))}
                                </div>
                                {selectedVariables.length > 0 && (
                                    <div style={{marginTop: '10px', paddingTop: '8px', borderTop: '1px solid #E2E8F0'}}>
                                        <div style={{fontWeight: '600', fontSize: '12px', marginBottom: '6px', color: '#334155'}}>Variables</div>
                                        {selectedVariables.map(v => (
                                            <div key={v.id} style={{display: 'flex', justifyContent: 'space-between', fontSize: '12px', padding: '2px 0'}}>
                                                <span style={{color: '#64748B'}}>{v.variable?.name}</span>
                                                <span style={{fontWeight: '500'}}>
                                                    {v.value != null ? v.value : '—'}
                                                    {v.variable?.unit ? ' ' + v.variable.unit : ''}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Route panel */}
                        <div style={{
                            padding: '16px',
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            border: '1px solid #E2E8F0',
                        }}>
                            <div
                                className="d-flex align-items-center gap-2 pointer-event"
                                style={{fontWeight: '600', fontSize: '14px', cursor: 'pointer'}}
                                onClick={() => setShowRoutePanel(!showRoutePanel)}
                            >
                                <FontAwesomeIcon icon={faRoute}/>
                                Draw Route
                            </div>

                            {showRoutePanel && (
                                <div className="mt-3 d-flex flex-column gap-2">
                                    <div style={{position: 'relative'}}>
                                        <input
                                            type="text"
                                            placeholder="Search by name, ID doc, or device..."
                                            value={routeAssetId ? routeSelectedName : routeSearch}
                                            onChange={e => {
                                                setRouteSearch(e.target.value);
                                                setRouteAssetId('');
                                                setRouteSelectedName('');
                                                setShowRouteDropdown(true);
                                            }}
                                            onFocus={() => setShowRouteDropdown(true)}
                                            onBlur={() => setTimeout(() => setShowRouteDropdown(false), 150)}
                                            style={{width: '100%', padding: '6px 8px', borderRadius: '4px', border: '1px solid #CBD5E1', fontSize: '13px'}}
                                        />
                                        {routeAssetId && (
                                            <span
                                                style={{position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#94A3B8', fontSize: '12px'}}
                                                onClick={() => { setRouteAssetId(''); setRouteSelectedName(''); setRouteSearch(''); }}
                                            >&times;</span>
                                        )}
                                        {showRouteDropdown && !routeAssetId && (
                                            <div style={{
                                                position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 10,
                                                maxHeight: '200px', overflowY: 'auto',
                                                backgroundColor: 'white', border: '1px solid #CBD5E1', borderRadius: '4px',
                                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                            }}>
                                                {assets.filter(a => searchFilter(a, (routeSearch || '').toLowerCase())).slice(0, 50).map(a => (
                                                    <div
                                                        key={a.id}
                                                        style={{padding: '6px 8px', cursor: 'pointer', fontSize: '13px', borderBottom: '1px solid #F1F5F9'}}
                                                        onMouseDown={() => {
                                                            setRouteAssetId(a.id);
                                                            setRouteSelectedName(a.name);
                                                            setRouteSearch('');
                                                            setShowRouteDropdown(false);
                                                        }}
                                                    >
                                                        <div style={{fontWeight: '500'}}>{a.name}</div>
                                                        <div style={{fontSize: '11px', color: '#94A3B8'}}>
                                                            {a.identification_number ? `Doc: ${a.identification_number}` : ''}
                                                            {a.identification_number && a.active_gps_device ? ' | ' : ''}
                                                            {a.active_gps_device ? `Device: ${a.active_gps_device.name}` : 'No GPS device'}
                                                        </div>
                                                    </div>
                                                ))}
                                                {assets.filter(a => searchFilter(a, (routeSearch || '').toLowerCase())).length === 0 && (
                                                    <div style={{padding: '8px', fontSize: '13px', color: '#94A3B8', textAlign: 'center'}}>No results</div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <label style={{fontSize: '12px', color: '#64748B'}}>{t('historic.from')}</label>
                                        <input
                                            type="datetime-local"
                                            value={routeFrom}
                                            onChange={e => { setRouteFrom(e.target.value); setRouteError(''); }}
                                            style={{width: '100%', padding: '6px 8px', borderRadius: '4px', border: '1px solid #CBD5E1', fontSize: '13px'}}
                                        />
                                    </div>
                                    <div>
                                        <label style={{fontSize: '12px', color: '#64748B'}}>{t('historic.to')}</label>
                                        <input
                                            type="datetime-local"
                                            value={routeTo}
                                            onChange={e => { setRouteTo(e.target.value); setRouteError(''); }}
                                            style={{width: '100%', padding: '6px 8px', borderRadius: '4px', border: '1px solid #CBD5E1', fontSize: '13px'}}
                                        />
                                    </div>
                                    {routeError && (
                                        <div style={{
                                            padding: '8px 10px',
                                            borderRadius: '6px',
                                            backgroundColor: '#FEF2F2',
                                            border: '1px solid #FECACA',
                                            color: '#DC2626',
                                            fontSize: '12px',
                                        }}>
                                            {routeError}
                                        </div>
                                    )}
                                    <div className="d-flex gap-2">
                                        <button
                                            onClick={drawRoute}
                                            style={{
                                                flex: 1, padding: '8px', borderRadius: '6px', border: 'none',
                                                backgroundColor: '#1E293B', color: 'white', fontSize: '13px', cursor: 'pointer'
                                            }}
                                        >
                                            Draw
                                        </button>
                                        {routePolyline && (
                                            <button
                                                onClick={clearRoute}
                                                style={{
                                                    padding: '8px 12px', borderRadius: '6px', border: '1px solid #CBD5E1',
                                                    backgroundColor: 'white', fontSize: '13px', cursor: 'pointer'
                                                }}
                                            >
                                                {t('historic.clear')}
                                            </button>
                                        )}
                                    </div>
                                    {routePoints.length > 0 && (
                                        <div style={{fontSize: '12px', color: '#64748B'}}>
                                            {routePoints.length} points found
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* Active Warnings Table */}
                        {(() => {
                            const sosAssets = assets.filter(a => positions[a.id]?.is_sos);
                            const totalWarnings = warnings.length + sosAssets.length;
                            return (
                                <div style={{
                                    padding: '12px',
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    border: totalWarnings > 0 ? '1px solid #FCA5A5' : '1px solid #E2E8F0',
                                }}>
                                    <div className="d-flex align-items-center gap-2" style={{fontWeight: '600', fontSize: '13px', color: totalWarnings > 0 ? '#EF4444' : '#334155', marginBottom: '8px'}}>
                                        <FontAwesomeIcon icon={faTriangleExclamation}/>
                                        Active Warnings ({totalWarnings})
                                    </div>
                                    {totalWarnings > 0 ? (
                                        <div className="d-flex flex-column gap-1">
                                            {sosAssets.map(a => (
                                                <div
                                                    key={`sos-${a.id}`}
                                                    onClick={() => openAssetPopup(a)}
                                                    className="d-flex align-items-center justify-content-between"
                                                    style={{
                                                        padding: '8px',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#F5F3FF',
                                                        border: '1px solid #C4B5FD',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    <div>
                                                        <div style={{fontWeight: '600', color: '#1E293B'}}>{a.name}</div>
                                                        <div style={{color: '#7C3AED', fontWeight: '600'}}>{t('gps.sos.sosButton')}</div>
                                                    </div>
                                                    <FontAwesomeIcon icon={faLocationCrosshairs} color="#7C3AED" size="sm"/>
                                                </div>
                                            ))}
                                            {warnings.map(w => (
                                                <div
                                                    key={w.id}
                                                    onClick={() => handleAlarmRowClick(w)}
                                                    className="d-flex align-items-center justify-content-between"
                                                    style={{
                                                        padding: '8px',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#FEF2F2',
                                                        border: '1px solid #FECACA',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    <div>
                                                        <div style={{fontWeight: '600', color: '#1E293B'}}>{w.device_user_name}</div>
                                                        <div style={{color: '#64748B'}}>
                                                            {w.warning_trigger === 'enter' && 'Entered'}
                                                            {w.warning_trigger === 'leave' && 'Left'}
                                                            {w.warning_trigger === 'overtime' && 'Overtime in'}
                                                            {' '}{w.zone_name}
                                                        </div>
                                                    </div>
                                                    <FontAwesomeIcon icon={faLocationCrosshairs} color="#64748B" size="sm"/>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div style={{fontSize: '12px', color: '#94A3B8', textAlign: 'center', padding: '8px'}}>
                                            {t('gps.assets.noData')}
                                        </div>
                                    )}
                                </div>
                            );
                        })()}

                        {/* Outdoor Cameras section */}
                        <div style={{ padding: '12px', backgroundColor: 'white', borderRadius: '8px', border: '1px solid #E2E8F0' }}>
                            <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ cursor: 'pointer' }}
                                onClick={() => setShowCameraPanel(v => !v)}
                            >
                                <div style={{ fontWeight: '600', fontSize: '13px', color: '#334155', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <FontAwesomeIcon icon={faVideo} style={{ color: '#06B6D4' }} />
                                    Outdoor Cameras ({mapCameras.length})
                                </div>
                                <span style={{ fontSize: '12px', color: '#94A3B8' }}>{showCameraPanel ? '▲' : '▼'}</span>
                            </div>
                            {showCameraPanel && (
                                <div className="mt-2 d-flex flex-column gap-2">
                                    <input
                                        type="text"
                                        placeholder="Search cameras..."
                                        value={cameraSearch}
                                        onChange={e => setCameraSearch(e.target.value)}
                                        style={{ width: '100%', padding: '6px 8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '12px', boxSizing: 'border-box' }}
                                    />
                                    <button
                                        onClick={() => { setCameraPlacementMode(v => !v); setCameraPickerSearch(''); }}
                                        style={{
                                            width: '100%', padding: '7px', borderRadius: '6px', border: 'none',
                                            backgroundColor: cameraPlacementMode ? '#06B6D4' : '#1E293B',
                                            color: 'white', fontSize: '12px', cursor: 'pointer',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                                        }}
                                    >
                                        {cameraPlacementMode
                                            ? <><FontAwesomeIcon icon={faTimes} /> Cancel placement</>
                                            : <><FontAwesomeIcon icon={faPlus} /> Add camera to map</>
                                        }
                                    </button>
                                    {(() => {
                                        const q = cameraSearch.toLowerCase();
                                        const filtered = mapCameras.filter(mc =>
                                            !q || mc.camera_name?.toLowerCase().includes(q) || (mc.machine_name || '').toLowerCase().includes(q)
                                        );
                                        if (filtered.length === 0) return (
                                            <div style={{ fontSize: '12px', color: '#94A3B8', textAlign: 'center', padding: '6px' }}>
                                                {mapCameras.length === 0 ? 'No outdoor cameras placed' : 'No results'}
                                            </div>
                                        );
                                        return filtered.map(mc => (
                                            <div
                                                key={mc.id}
                                                onClick={() => { setSelectedCamera(mc); setSelectedAsset(null); }}
                                                style={{
                                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                    padding: '8px', borderRadius: '6px', cursor: 'pointer',
                                                    backgroundColor: selectedCamera?.id === mc.id ? '#E0F7FA' : '#F8FAFC',
                                                    border: selectedCamera?.id === mc.id ? '1px solid #06B6D4' : '1px solid #E2E8F0',
                                                    fontSize: '12px',
                                                }}
                                            >
                                                <div>
                                                    <div style={{ fontWeight: '600', color: '#1E293B' }}>{mc.camera_name}</div>
                                                    {mc.machine_name && <div style={{ color: '#64748B' }}>{mc.machine_name}</div>}
                                                </div>
                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                    <button
                                                        onClick={(e) => { e.stopPropagation(); setSelectedCamera(mc); setShowCameraViewer(true); }}
                                                        style={{ background: 'none', border: 'none', color: '#06B6D4', cursor: 'pointer', padding: '2px 6px' }}
                                                        title="View camera"
                                                    >
                                                        <FontAwesomeIcon icon={faVideo} />
                                                    </button>
                                                    <button
                                                        onClick={async (e) => {
                                                            e.stopPropagation();
                                                            if (!window.confirm(`Remove camera "${mc.camera_name}" from map?`)) return;
                                                            try {
                                                                await axiosInstance.delete(`map_camera/${mc.id}/`);
                                                                setMapCameras(prev => prev.filter(x => x.id !== mc.id));
                                                                if (selectedCamera?.id === mc.id) { setSelectedCamera(null); setShowCameraViewer(false); }
                                                            } catch (err) { console.error(err); }
                                                        }}
                                                        style={{ background: 'none', border: 'none', color: '#EF4444', cursor: 'pointer', padding: '2px 6px' }}
                                                        title="Remove from map"
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </div>
                                            </div>
                                        ));
                                    })()}
                                </div>
                            )}
                        </div>

                        {/* Indoor section */}
                        <GPSIndoorContent project_id={project_id} mapApi={mapApi} mapInstance={mapInstance} defaultCenter={mapCenter} defaultZoom={mapZoom}/>
                    </div>
                </div>
            </div>

            {/* Camera viewer modal */}
            {showCameraViewer && selectedCamera && (
                <div style={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
                }}>
                    <div style={{
                        backgroundColor: '#1E293B', borderRadius: '12px', padding: '16px',
                        width: '620px', maxWidth: '95vw',
                        display: 'flex', flexDirection: 'column', boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
                    }}>
                        <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: '12px' }}>
                            <div style={{ fontWeight: '700', fontSize: '14px', color: '#fff', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <FontAwesomeIcon icon={faVideo} style={{ color: '#06B6D4' }} />
                                {selectedCamera.camera_name}
                                {selectedCamera.machine_name && <span style={{ fontWeight: '400', fontSize: '12px', color: '#94A3B8' }}>{selectedCamera.machine_name}</span>}
                            </div>
                            <button
                                onClick={() => setShowCameraViewer(false)}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94A3B8', fontSize: '18px' }}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <CameraViewer cameraId={selectedCamera.camera} name={selectedCamera.camera_name} camera={selectedCamera} />
                    </div>
                </div>
            )}

            {/* Camera picker modal */}
            {showCameraPicker && (
                <div style={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '20px',
                        width: '420px', maxWidth: '95vw', maxHeight: '80vh',
                        display: 'flex', flexDirection: 'column', boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
                    }}>
                        <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: '12px' }}>
                            <div style={{ fontWeight: '700', fontSize: '15px', color: '#1E293B' }}>
                                <FontAwesomeIcon icon={faVideo} style={{ color: '#06B6D4', marginRight: '8px' }} />
                                Select Camera
                            </div>
                            <button onClick={() => { setShowCameraPicker(false); setCameraPlacementMode(false); setPendingCameraLatLng(null); }}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748B', fontSize: '18px' }}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <input
                            type="text"
                            placeholder="Search cameras..."
                            value={cameraPickerSearch}
                            onChange={e => setCameraPickerSearch(e.target.value)}
                            autoFocus
                            style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px', marginBottom: '10px', boxSizing: 'border-box' }}
                        />
                        <div style={{ overflowY: 'auto', flex: 1 }}>
                            {(() => {
                                const placedIds = new Set(mapCameras.map(mc => mc.camera));
                                const available = allCameras.filter(c =>
                                    !c.has_floor_placement &&
                                    !c.has_map_placement &&
                                    !placedIds.has(c.id) &&
                                    (cameraPickerSearch === '' ||
                                        c.name.toLowerCase().includes(cameraPickerSearch.toLowerCase()) ||
                                        (c.machine_name || '').toLowerCase().includes(cameraPickerSearch.toLowerCase()))
                                );
                                if (available.length === 0) {
                                    return <div style={{ textAlign: 'center', color: '#94A3B8', fontSize: '13px', padding: '20px' }}>No available cameras</div>;
                                }
                                return available.map(cam => (
                                    <div
                                        key={cam.id}
                                        onClick={async () => {
                                            if (!pendingCameraLatLng || cameraLoading) return;
                                            setCameraLoading(true);
                                            try {
                                                const res = await axiosInstance.post('map_camera/', {
                                                    camera: cam.id,
                                                    latitude: pendingCameraLatLng.lat,
                                                    longitude: pendingCameraLatLng.lng,
                                                });
                                                setMapCameras(prev => [...prev, res.data]);
                                                setAllCameras(prev => prev.map(c => c.id === cam.id ? { ...c, has_map_placement: true } : c));
                                            } catch (err) {
                                                const data = err?.response?.data;
                                                console.error('map_camera POST error:', data);
                                                const msg = data?.error
                                                    || (data && typeof data === 'object' ? JSON.stringify(data) : null)
                                                    || (typeof data === 'string' ? data.slice(0, 300) : null)
                                                    || err?.message
                                                    || 'Error placing camera';
                                                alert(msg);
                                            } finally {
                                                setCameraLoading(false);
                                                setShowCameraPicker(false);
                                                setCameraPlacementMode(false);
                                                setPendingCameraLatLng(null);
                                                setCameraPickerSearch('');
                                            }
                                        }}
                                        style={{
                                            padding: '10px 12px', borderRadius: '8px', cursor: 'pointer',
                                            border: '1px solid #E2E8F0', marginBottom: '6px',
                                            backgroundColor: '#F8FAFC',
                                            transition: 'background 0.15s',
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#E0F7FA'}
                                        onMouseLeave={e => e.currentTarget.style.backgroundColor = '#F8FAFC'}
                                    >
                                        <div style={{ fontWeight: '600', fontSize: '13px', color: '#1E293B' }}>{cam.name}</div>
                                        {cam.machine_name && <div style={{ fontSize: '11px', color: '#64748B' }}>{cam.machine_name}</div>}
                                    </div>
                                ));
                            })()}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
